import { useState } from "react"
import { toast } from "@/v2-ui/toast"
import Button, {
  type ButtonProps,
} from "@/v2-backoffice-client/components/button"
import { useAppViewSheetOpener } from "@/v2-backoffice-client/app/app.utils"
import CustomerCreateDialog from "@/v2-backoffice-client/customer/create/CustomerCreateDialog"

export type CustomerCreateButtonProps = ButtonProps

// Create flow: the create dialog does the whole job — duplicate check,
// HubSpot link or creation — and the new customer's panel opens right after,
// so the operator lands on what they just made. Picking an existing customer
// from the dialog's matches opens that one instead.
function CustomerCreateButton(props: CustomerCreateButtonProps) {
  const { onClick, ...buttonProps } = props
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const opener = useAppViewSheetOpener()

  return (
    <>
      <Button
        variant="primary"
        size="tiny"
        iconSrc="plus"
        iconSize={10}
        onClick={(e) => {
          setIsCreateOpen(true)
          onClick?.(e)
        }}
        {...buttonProps}
      >
        Create customer
      </Button>

      <CustomerCreateDialog
        open={isCreateOpen}
        onOpenChange={setIsCreateOpen}
        onCreated={(customer) => {
          // Every created customer now carries a join key (its HubSpot
          // company id, or a generated one), which is what the panel is
          // keyed by.
          if (customer.ExternalCustomerId) {
            opener.open("customer", customer.ExternalCustomerId)
          }
        }}
        onOpenExisting={(candidate) => {
          if (candidate.ExternalCustomerId) {
            opener.open("customer", candidate.ExternalCustomerId)
            return
          }
          // Pre-existing app-only customers created before join keys were
          // seeded have no panel key; the board still finds them by name.
          toast({
            title: `${candidate.Name} exists in Backoffice`,
            description:
              "It has no panel key yet — search for it by name on the Customers board.",
          })
        }}
      />
    </>
  )
}

export default CustomerCreateButton
